export default class ProductTileSwipe {
    static init(tile) {
        const mainImage = tile.querySelector('.has-second-image');
        const additionalImage = tile.querySelector('.additional-image');
        const imagesWrapper = tile.querySelector('.images-wrapper');
        if (mainImage && additionalImage && imagesWrapper) {
            let index = 0;
            let touchStart = 0;
            let moveX = null;
            const mainImageWidth = mainImage.offsetWidth;
            const baseWidth = mainImageWidth + (imagesWrapper.offsetWidth - mainImageWidth + 1) / 2;
            tile.querySelectorAll('.images-wrapper').forEach((image) => {
                image.addEventListener('touchstart', (e) => {
                    touchStart = e.touches[0].pageX;
                    mainImage.classList.remove('animate');
                    additionalImage.classList.remove('animate');
                });
                image.addEventListener('touchmove', (e) => {
                    moveX = touchStart - e.touches[0].pageX;
                    if (Math.abs(moveX) < baseWidth + 30) {
                        if (moveX > 0 && index === 0) {
                            mainImage.style.transform = 'translateX(-' + moveX + 'px)';
                            additionalImage.style.transform = 'translate(' + (baseWidth - moveX) + 'px, -100%)';
                        }
                        else if (moveX < 0 && index === 1) {
                            mainImage.style.transform = 'translateX(' + (Math.abs(moveX) - baseWidth) + 'px)';
                            additionalImage.style.transform = 'translate(' + -moveX + 'px, -100%)';
                        }
                    }
                });
                image.addEventListener('touchend', () => {
                    mainImage.classList.add('animate');
                    additionalImage.classList.add('animate');
                    if (moveX && moveX > baseWidth / 2) {
                        index = 1;
                        mainImage.style.transform = 'translateX(-' + baseWidth + 'px)';
                        additionalImage.style.transform = 'translate(0, -100%)';
                    }
                    else {
                        index = 0;
                        mainImage.style.transform = 'translateX(0)';
                        additionalImage.style.transform = 'translate(' + baseWidth + 'px, -100%)';
                    }
                });
            });
        }
    }
}
